import React from "react";
import { motion } from "framer-motion";
import { FaEnvelope, FaPhoneAlt, FaComments } from "react-icons/fa";
import "./ContactExpertsSection.css";
import expertBg from "../../assets/Institute/DSC_3042.JPG";

const ContactExpertsSection = () => {
  return (
    <section
      className="experts-clean-section"
      style={{ backgroundImage: `url(${expertBg})` }}
    >
      <div className="overlay">
        <motion.div
          className="experts-center-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h2 className="experts-heading">
            Talk to our <span>Experts</span>
          </h2>

          <p className="experts-text">
            Have questions about our courses or admissions?  
            Our friendly team is ready to guide you through every step of your
            NIECCE journey — from enrolment to placement.
          </p>

          <div className="experts-details">
            <p>
              <FaComments className="icon" /> Live Expert Consultation
            </p>
            <p>
              <FaEnvelope className="icon" />{" "}
              <a href="mailto:info@niecce.com">info@niecce.com</a>
            </p>
            <p>
              <FaPhoneAlt className="icon" /> <a href="tel:+919886855700">+91 98868 55700</a>
            </p>
          </div>

          <motion.a
            href="/contact"
            className="experts-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Contact Us
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactExpertsSection;
